export default function isBadCoordinate(coordinate) {
  if (!coordinate) {
    return true;
  }
  if (coordinate < -180 || coordinate > 180) {
    return true;
  }
  return false;
}




// WEBPACK FOOTER //
// ./src/utils/isBadCoordinate.js